const TipoChatHub = {
  Mensagem: 1,
  Atendimento: 2,
  Etapa: 3
};

export default TipoChatHub;
